var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProviderConfirmation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176.466,
    height: 144.531,
    viewBox: "0 0 176.466 144.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6630",
    "data-name": "Path 6630",
    d: "M532.829,171.2A63.014,63.014,0,0,1,459.5,233.4q-1.476-.241-2.931-.554-1.971-.419-3.9-.963A63.039,63.039,0,1,1,532.829,171.2Z",
    transform: "translate(-363.477 -108.171)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6631",
    "data-name": "Path 6631",
    d: "M507.2,403.618a.475.475,0,0,0-.2.642l23.7,44.388a.475.475,0,0,0,.642.2l33.5-17.886a.475.475,0,0,0,.2-.642l-23.7-44.388a.475.475,0,0,0-.642-.2Z",
    transform: "translate(-440.359 -321.131)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6632",
    "data-name": "Path 6632",
    d: "M515.2,416.018l21.687,40.618,29.731-15.873L544.93,400.144Zm-1.884,1.006,0,0,0,0Z",
    transform: "translate(-445.243 -332.234)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6633",
    "data-name": "Path 6633",
    d: "M552.252,448.957a1.177,1.177,0,0,0-.22,1.6c.341.638.994.957,1.455.71l21.775-11.626a1.177,1.177,0,0,0,.22-1.6c-.341-.638-.994-.957-1.455-.71Z",
    transform: "translate(-474.8 -360.708)",
    fill: "#122aff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6634",
    "data-name": "Path 6634",
    d: "M563.786,470.562a1.177,1.177,0,0,0-.22,1.6c.341.638.994.957,1.455.71L586.8,461.251a1.177,1.177,0,0,0,.22-1.6c-.341-.638-.994-.957-1.455-.71Z",
    transform: "translate(-483.652 -377.287)",
    fill: "#122aff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6635",
    "data-name": "Path 6635",
    d: "M575.321,492.166a1.177,1.177,0,0,0-.22,1.6c.341.638.994.957,1.455.71l21.775-11.626a1.177,1.177,0,0,0,.22-1.6c-.341-.638-.994-.957-1.455-.71Z",
    transform: "translate(-492.504 -393.867)",
    fill: "#122aff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6636",
    "data-name": "Path 6636",
    d: "M586.855,513.771a1.177,1.177,0,0,0-.22,1.6c.341.638.994.957,1.455.71l21.775-11.626a1.177,1.177,0,0,0,.22-1.6c-.341-.638-.994-.957-1.455-.71Z",
    transform: "translate(-501.356 -410.446)",
    fill: "#122aff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6637",
    "data-name": "Path 6637",
    d: "M598.39,535.375a1.177,1.177,0,0,0-.22,1.6c.341.638.994.957,1.455.71L621.4,526.064a1.177,1.177,0,0,0,.219-1.6c-.341-.638-.994-.957-1.455-.71Z",
    transform: "translate(-510.207 -427.025)",
    fill: "#122aff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6638",
    "data-name": "Path 6638",
    d: "M397.312,209.734l19.731,1.2,5.526-16.479L405.262,190.8Z",
    transform: "translate(-304.901 -146.425)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 7.891,
    cy: 7.891,
    r: 7.891,
    transform: "translate(98.75 43.361)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6639",
    "data-name": "Path 6639",
    d: "M654.722,550.175l.051.614a63.441,63.441,0,0,1-30.928,2.619l-2.931-.554,2.789-6.185,1.828-4.054-.658-14.025-.07-1.451-.086-1.851,1.191-.007,8.466-.051,8.069-.051,1.23-.007C651.389,534.661,657.755,542.374,654.722,550.175Z",
    transform: "translate(-527.817 -428.181)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6640",
    "data-name": "Path 6640",
    d: "M650.456,404.918l-18.84,2.093-.7-13.025c-2.211-5.639-.751-10.672,3.837-15.189l.933-3.693a5.467,5.467,0,0,1,4.038-3.98h0a19.465,19.465,0,0,1,10.5-2.491h0a7.833,7.833,0,0,1,4.96,7.905A145.121,145.121,0,0,1,650.456,404.918Z",
    transform: "translate(-534.716 -308.044)",
    fill: "#122aff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6641",
    "data-name": "Path 6641",
    d: "M626.178,280.395s-4.08,1.489-4.185,6.9a9.777,9.777,0,0,0,.361,2.7c.265.995.477,3.154-1.3,6.031a55.792,55.792,0,0,0-3.148,5.795h0l4.594.443.76-7.616a37.8,37.8,0,0,1,2.7-10.738l.03-.072s2.108,3.663,6.114,3.551L630.632,286a50.53,50.53,0,0,0,7.746,2.269,1.728,1.728,0,0,1,1.041,2.873l-.049.053c-1.669,1.765-4.989,5.868-2.9,8.959s.4,4,.4,4l3.1-1.805,1.406-.9.032,1.145,7.416-1.068s1.995-.343-2.434-5.086a5.1,5.1,0,0,1-.737-3.5,8.221,8.221,0,0,0,.2-3.852C644.745,283.745,640.672,273.187,626.178,280.395Z",
    transform: "translate(-525.507 -238.467)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6642",
    "data-name": "Path 6642",
    d: "M220.824,414.872a.233.233,0,0,0-.165.285l6.347,23.824a.233.233,0,0,0,.285.165l17.98-4.791a.233.233,0,0,0,.165-.285l-6.347-23.824a.233.233,0,0,0-.285-.165Z",
    transform: "translate(-220.652 -339.854)",
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6643",
    "data-name": "Path 6643",
    d: "M239.355,437.308a.577.577,0,0,0-.284.741c.091.342.367.567.615.5l11.687-3.114a.577.577,0,0,0,.284-.741c-.091-.342-.367-.567-.615-.5Z",
    transform: "translate(-234.765 -358.355)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6644",
    "data-name": "Path 6644",
    d: "M242.445,448.9a.577.577,0,0,0-.284.741c.091.342.367.567.615.5l11.687-3.114a.577.577,0,0,0,.284-.741c-.091-.342-.367-.567-.615-.5Z",
    transform: "translate(-237.135 -367.254)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    "data-name": "Path 6645",
    d: "M245.534,460.5a.577.577,0,0,0-.284.741c.091.342.367.567.615.5l11.687-3.114a.577.577,0,0,0,.284-.741c-.091-.342-.367-.568-.615-.5Z",
    transform: "translate(-239.506 -376.152)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6646",
    "data-name": "Path 6646",
    d: "M248.623,472.095a.577.577,0,0,0-.284.741c.091.342.367.568.615.5l11.687-3.114a.577.577,0,0,0,.284-.741c-.091-.342-.367-.567-.615-.5Z",
    transform: "translate(-241.877 -385.051)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6647",
    "data-name": "Path 6647",
    d: "M251.713,483.69a.577.577,0,0,0-.284.741c.091.342.367.567.615.5l11.687-3.114a.577.577,0,0,0,.284-.741c-.091-.342-.367-.568-.615-.5Z",
    transform: "translate(-244.248 -393.949)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6648",
    "data-name": "Path 6648",
    d: "M254.8,495.286a.577.577,0,0,0-.284.741c.091.342.367.567.615.5l11.687-3.114a.577.577,0,0,0,.284-.741c-.091-.342-.367-.567-.615-.5Z",
    transform: "translate(-246.618 -402.848)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6656",
    "data-name": "Path 6656",
    d: "M223.824,327.784a.233.233,0,0,0-.1.315l11.612,21.749a.233.233,0,0,0,.315.1l16.414-8.764a.233.233,0,0,0,.1-.315l-11.612-21.749a.233.233,0,0,0-.315-.1Z",
    transform: "translate(-222.991 -269.958)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6657",
    "data-name": "Path 6657",
    d: "M227.743,333.859l10.626,19.9,14.568-7.777-10.626-19.9Zm-.923.493h0Z",
    transform: "translate(-225.385 -275.398)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6658",
    "data-name": "Path 6658",
    d: "M245.9,350a.577.577,0,0,0-.108.786c.167.313.487.469.713.348l10.669-5.7a.577.577,0,0,0,.108-.786c-.167-.313-.487-.469-.713-.348Z",
    transform: "translate(-239.867 -289.349)",
    fill: "#122aff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6659",
    "data-name": "Path 6659",
    d: "M251.55,360.585a.577.577,0,0,0-.108.786c.167.313.487.469.713.348l10.669-5.7a.577.577,0,0,0,.108-.786c-.167-.313-.487-.469-.713-.348Z",
    transform: "translate(-244.205 -297.473)",
    fill: "#122aff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6660",
    "data-name": "Path 6660",
    d: "M257.2,371.171a.577.577,0,0,0-.108.786c.167.313.487.469.713.348l10.669-5.7a.577.577,0,0,0,.108-.786c-.167-.313-.487-.469-.713-.348Z",
    transform: "translate(-248.542 -305.596)",
    fill: "#122aff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6661",
    "data-name": "Path 6661",
    d: "M262.854,381.756a.577.577,0,0,0-.108.786c.167.313.487.469.713.348l10.669-5.7a.577.577,0,0,0,.108-.786c-.167-.313-.487-.469-.713-.348Z",
    transform: "translate(-252.879 -313.72)",
    fill: "#122aff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6662",
    "data-name": "Path 6662",
    d: "M268.505,392.342a.577.577,0,0,0-.108.786c.167.313.487.469.713.348l10.669-5.7a.577.577,0,0,0,.108-.786c-.167-.313-.487-.469-.713-.348Z",
    transform: "translate(-257.216 -321.844)",
    fill: "#122aff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6663",
    "data-name": "Path 6663",
    d: "M274.157,402.928a.577.577,0,0,0-.108.786c.167.313.487.469.713.348l10.669-5.7a.577.577,0,0,0,.108-.786c-.167-.313-.487-.469-.713-.348Z",
    transform: "translate(-261.554 -329.967)",
    fill: "#122aff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6664",
    "data-name": "Path 6664",
    d: "M867.442,595.64a.233.233,0,0,0-.319.082L854.58,616.947a.233.233,0,0,0,.082.319l16.019,9.467a.233.233,0,0,0,.319-.082l12.543-21.226a.233.233,0,0,0-.082-.319Z",
    transform: "translate(-707.11 -482.234)",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6665",
    "data-name": "Path 6665",
    d: "M873.19,601.014l-11.478,19.423,14.217,8.4,11.478-19.424Zm-.9-.532h0Z",
    transform: "translate(-712.607 -485.974)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6666",
    "data-name": "Path 6666",
    d: "M908.449,620.991a.677.677,0,0,0-.654,1.107l10.413,6.153a.677.677,0,0,0,.654-1.107Z",
    transform: "translate(-747.825 -501.676)",
    fill: "#122aff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6667",
    "data-name": "Path 6667",
    d: "M902.344,631.322a.677.677,0,0,0-.654,1.107l10.413,6.153a.677.677,0,0,0,.654-1.107Z",
    transform: "translate(-743.141 -509.605)",
    fill: "#122aff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6672",
    "data-name": "Path 6672",
    d: "M609.714,429.671l-.242,1.5-2.549,15.714-1.6,5.11-.563,1.8-.472,1.512-5.738,18.328-1.574,3.7a4.418,4.418,0,1,0,5.167,1.631l11.231-26.126.416-.893,1.275-2.733,2.407-18.163.151-1.142Z",
    transform: "translate(-507.232 -354.893)",
    fill: "#ffb8b8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6673",
    "data-name": "Path 6673",
    d: "M666.731,391.615a13.71,13.71,0,0,0-10.467,0l1.079-9.349a4.459,4.459,0,0,1,4.222-4.6h0a4.459,4.459,0,0,1,4.687,4.218v.015Z",
    transform: "translate(-554.945 -314.976)",
    fill: "#122aff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderConfirmation);
export default __webpack_public_path__ + "static/media/provider-confirmation.d2e5e631.svg";
export { ForwardRef as ReactComponent };